import { Card, Skeleton } from "antd";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useLocation } from "react-router-dom";
import HTTP from "../../services/httpService";
import CustomHeader from "../common/Header";

const grid = [
    /* {
		lable: "Operation ID",
		key: "operation_id",
	}, */
    {
        lable: "Call ID",
        key: "call_id",
    },
    /* {
		lable: "Staff ID",
		key: "staff_id",
	}, */
    /* {
		lable: "Call From",
		key: "call_start_by",
	}, */
    {
        lable: "Call Started",
        key: ["call_start_at_kiosk_time", "call_start_at_staff_time"],
    },
    {
        lable: "Call Started At Backend",
        key: "call_start_received_at_backend_time",
    },
    {
        lable: "Call Started Socket Sent",
        key: "call_start_socket_send_from_backend_time",
    },
    {
        lable: "Call Picked-Up",
        key: ["call_pickup_at_kiosk_time", "call_pickup_at_staff_time"],
    },
    {
        lable: "Call Picked-Up At Backend",
        key: "call_pickup_received_at_backend_time",
    },
    {
        lable: "Call Picked-Up Socket Sent",
        key: "call_pickup_socket_send_from_backend_time",
    },
    {
        lable: "Call Hanged-Up",
        key: ["call_hangup_at_kiosk_time", "call_hangup_at_staff_time"],
    },
    {
        lable: "Call Hanged-Up At Backend",
        key: "call_hangup_received_at_backend_time",
    },
    {
        lable: "Call Hanged-Up Socket Send",
        key: "call_hangup_socket_send_from_backend_time",
    },
    {
        lable: "Call Disconnected",
        key: ["call_disconnect_at_kiosk_time", "call_disconnect_at_staff_time"],
    },
    {
        lable: "Call Disconnected At Backend",
        key: "call_disconnect_received_at_backend_time",
    },
    {
        lable: "Call Disconnected Socket Send",
        key: "call_disconnect_socket_send_from_backend_time",
    },
];

function CallTimingsCard() {
    const { state } = useLocation();
    const [cardData, setCardData] = useState({});
    const { operation_id, call_id, staff_id } = state;
    const formData = { operation_id, call_id, staff_id };

    const {
        status,
        data: callTimingData,
        refetch: getCallTimings,
    } = useQuery(
        "call-time",
        async () => {
            return await HTTP("/dashboard/getSingleNewCallDetails", {
                ...formData,
            });
        },
        { enabled: false },
    );

    useEffect(() => {
        getCallTimings();
    }, []);

    useEffect(() => {
        if (status === "success") {
            const [resData] = callTimingData.data;
            const gridData = grid.map((gridElement) => {
                if (Array.isArray(gridElement.key)) {
                    const finalKey = gridElement.key.reduce((prev, cur) => {
                        if (prev !== "-") {
                            if (resData[cur] !== "-") return cur;
                            else if (resData[prev] !== "-") return prev;
                            else return undefined;
                        } else {
                            return cur;
                        }
                    }, "-");
                    gridElement.value =
                        finalKey !== undefined ? resData[finalKey] : "-";
                } else {
                    gridElement.value = resData[gridElement.key];
                }
                return gridElement;
            });
            setCardData(gridData);
        }
    }, [status, callTimingData]);
    return (
        <Card className="dashboard-container">
            <CustomHeader />
            {cardData.length > 0 ? (
                <Card>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
                        {cardData.map((e) => {
                            return (
                                <p key={e.lable}>
                                    <span
                                        style={{
                                            fontSize: "14px",
                                            fontWeight: "600",
                                            color: "#198ffc",
                                        }}
                                    >
                                        {e.lable}
                                    </span>
                                    {` : `}
                                    <span>{e.value}</span>
                                </p>
                            );
                        })}
                    </div>
                </Card>
            ) : (
                <Skeleton />
            )}
        </Card>
    );
}

export { CallTimingsCard };
